import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { GroupAdBlock } from '../blocks.types'

export const StandardGroupAdBlockFragment: BlockFragment = {
  name: 'standardGroupAd',
  fragment: gql`
    fragment standardGroupAd on StandardGroupAd {
      id
      blockType
      title
      description
      image {
        url
        alt
      }
      imageRatio
      link
      linkText
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on StandardGroupAd {
      id
      blockType
      title
      description
      image {
        url
        alt
      }
      imageRatio
      link
      linkText
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const StandardGroupAdBlockType = 'standardGroupAd'

export interface StandardGroupAdBlock extends GroupAdBlock {
  blockType: typeof StandardGroupAdBlockType
  title: string
  description: string
  image: {
    url: string
    alt: string
  }
  imageRatio: string
  link: string
  linkText: string
}
